import React from 'react';
import { Edit, Trash2, Users, UserPlus } from 'lucide-react';
import { Course } from '../types';

interface CoursesTableProps {
  courses: Course[];
  onDelete: (id: number) => Promise<void>;
  onEdit?: (course: Course) => void;
  onAssign?: (courseId: number) => void;
}

const CoursesTable: React.FC<CoursesTableProps> = ({ courses, onDelete, onEdit, onAssign }) => {
  if (!courses || !Array.isArray(courses)) {
    return <div>No courses available</div>;
  }

  return (
    <div className="bg-gray-800 rounded-lg shadow-lg overflow-hidden">
      <table className="w-full">
        <thead className="bg-gray-700">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Title</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Modules</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Assignment</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-700">
          {courses.map((course) => (
            <tr key={course.id}>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="font-medium">{course.title}</div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">{course.modules?.length || 0}</td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  {course.is_assigned_to_all ? (
                    <span className="px-2 py-1 text-xs bg-blue-500/20 text-blue-300 rounded-full flex items-center">
                      <Users className="h-3 w-3 mr-1" />
                      All Users
                    </span>
                  ) : (
                    <span className="px-2 py-1 text-xs bg-gray-500/20 text-gray-400 rounded-full">
                      Specific Users
                    </span>
                  )}
                  {onAssign && !course.is_assigned_to_all && (
                    <button
                      onClick={() => onAssign(course.id)}
                      className="ml-2 text-blue-400 hover:text-blue-300"
                      title="Assign to Users"
                    >
                      <UserPlus className="h-4 w-4" />
                    </button>
                  )}
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex space-x-2">
                  <button 
                    onClick={() => onEdit && onEdit(course)}
                    className="text-blue-400 hover:text-blue-300"
                    title="Edit Course"
                  >
                    <Edit className="h-5 w-5" />
                  </button>
                  <button 
                    onClick={() => onDelete(course.id)}
                    className="text-red-400 hover:text-red-300"
                    title="Delete Course"
                  >
                    <Trash2 className="h-5 w-5" />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CoursesTable;